import fetch from "../utils/fetch";

/**
 * apphi登录
 * @param basic 用户名密码加密后字符串
 * @param ignoreToken 是否采用新basic替换原有token
 * @returns {*}
 */
export function login({ basic, ignoreToken, with_stripe }) {
  console.log("login api begin");
  return fetch.get("users/self", {
    ignoreToken,
    headers: {
      Authorization: `Basic ${basic}`
    },
    params: {
      with_stripe
    }
  });
}
/**
 * 注册账号
 * @param email 邮箱
 * @param password 密码
 * @returns {*|void|AxiosPromise<any>}
 */
export function register({ email, password }) {
  return fetch.post("users", {
    email,
    password
  });
}
/**
 * 与指定 publisher 建立绑定关系。
 * http://schedulepost.dev.apphi.com/api/docs/#!/users/Publiship_Model_create
 * @param publisher_username Instagram username
 * @param publisher_password Instagram password
 */
export function createPubliships({
  publisher_username,
  publisher_password,
  validation_api_path,
  validation_code
}) {
  return fetch.post(
    "users/self/publiships",
    {
      publisher_username,
      publisher_password,
      validation_api_path,
      validation_code
    },
    { ignore401: true, timeout: 40000 }
  );
}

/**
 * 解除绑定关系
 * http://schedulepost.dev.apphi.com/api/docs/#!/users/Publiship_Model_destroy
 * @param pk publisher标识(自己猜的)
 */
export function delPubliships({ pk }) {
  return fetch.delete(`users/self/publiships/${pk}`);
}

/**
 * 批量绑定publisher到member
 * http://schedulepost.dev.apphi.com/api/docs/#!/users/Membership_Model_bulk_create
 * @param member_email member email
 * @param publisher_ids publisher id，多个以逗号分隔。
 * @returns {*}
 */
export function bulkCreateMember({ member_email, publisher_ids }) {
  return fetch.post(`users/self/members`, { member_email, publisher_ids });
}

/**
 * 批量修改member的publisher
 * @param memberId member标识
 * @param publisher_ids publisher标识 多个用逗号隔开
 * @returns {*}
 */
export function bulkModifyMember({ memberId, publisher_ids }) {
  return fetch.post(`/users/self/members/${memberId}/publiships`, {
    publisher_ids
  });
}

/**
 * 删除member中的一个publisher
 * http://schedulepost.dev.apphi.com/api/docs/#!/users/Membership_Model_destroy
 * @param pk publisher 对应Id
 * @param memberId member对应Id
 */
export function delMemberships({ memberId, pk }) {
  return fetch.delete(`users/self/members/${memberId}/publiships/${pk}`);
}

/**
 * 刪除整个member
 * http://schedulepost.dev.apphi.com/api/docs/#!/users/Membership_Model_destroy_0
 * @param id
 */
export function delMember({ id }) {
  return fetch.delete(`users/self/members/${id}`);
}

/**
 * 修改member信息
 * http://schedulepost.dev.apphi.com/api/docs/#!/users/Member_Model_update
 * @param member_id member唯一标示
 * @param new_member_email member邮箱
 * @returns {IDBRequest | Promise<void>}
 */
export function modifyMember({ memberId, new_member_email }) {
  return fetch.put(`users/self/members/${memberId}`, { new_member_email });
}

/**
 * 批量绑定unlimited 用户
 * @param ids 用户id
 * @param is_premium 是否限制为unlimted用户
 * @returns {*}
 */
export function mulModifyUnlimited({ ids, is_premium }) {
  return fetch.patch(`users/self/publiships`, { ids, is_premium });
}

/**
 * 更新信用卡信息
 */
export function updatePaymentMethod({ credit_card }) {
  return fetch.patch(`users/self`, { credit_card });
}



// WEBPACK FOOTER //
// ./src/apis/users.js